const tenantId = "415e0d53-f637-4ae8-86ef-595ee20e0449";
const clientId = "4ad279ff-f035-41dd-a5b1-38df99561da8";
const loginAzureBaseUrl = `https://idp.ciam.dev.baaskit.com/${tenantId}/oauth2/v2.0/authorize`;
const tokenAzureBaseUrl = `https://idp.ciam.dev.baaskit.com/${tenantId}/oauth2/v2.0/token`

// Generate PKCE code_verifier and code_challenge
const codeVerifier = sessionStorage.getItem('codeVerifier') || btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32)))).replace(/[+/=]/g, (m) => ({ '+': '-', '/': '_', '=': '' }[m]!));
const codeChallenge = codeVerifier;
sessionStorage.setItem('codeVerifier', codeVerifier);

export const environment = {
  production: false,
  local: false,
  baseUrl: "https://api.dev.baaskit.com/v1/cl",
  graphqlUrl: "https://graphql.dev.baaskit.com/graphql",
  tokenUrl: "https://api.dev.baaskit.com/v1/cl/oauth2/token",
  loginAzureBaseUrl,
  clientId,
  quickSightBaseUrl: "https://api.dev.baaskit.com/v1/cl/dashboard",
  quickSightDashboards: {
    dashboard: "cda81cfa-7b2d-44da-b6c1-edffb5e27ed4", //'e72d1684-28ff-11ef-bdc6-00155d0f0547',
    credits: "328fb255-a2bc-4fc2-8af5-9f5e06b76adc",
    sales: "6c377602-7c6c-4253-9a53-cc47bd5bf8a2", //'898888c7-a575-4848-9740-3f0223d6aa62'
    conciliations_general_v2: "b7a0b0dd-8cd0-4c67-afb8-c288effec662",
    conciliations_detail_v2: "4c1bf529-3ee9-4a93-83b6-79e70652ef81",
    conciliations_dashboard: "5a4bd23c-1c81-4b9d-8944-d32433229d23",
  },
  tenantId,
  codeVerifier,
  codeChallenge,
  tokenAzureBaseUrl,
  authTokenScope: 'profile email openid api://api.ciam.dev.baaskit.com/cl.merchant.read.user'
};
